/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetpulsifycover3Inputs */

const en_formatpresetpulsifycover3 = /** @type {(inputs: Formatpresetpulsifycover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify Cover`)
};

const de_formatpresetpulsifycover3 = /** @type {(inputs: Formatpresetpulsifycover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify-Cover`)
};

/**
* | output |
* | --- |
* | "Pulsify Cover" |
*
* @param {Formatpresetpulsifycover3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetpulsifycover3 = /** @type {((inputs?: Formatpresetpulsifycover3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetpulsifycover3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetpulsifycover3(inputs)
	return de_formatpresetpulsifycover3(inputs)
});
export { formatpresetpulsifycover3 as "formatPresetPulsifyCover" }